<template>
  <div
    class="w-full px-3 py-2 border-1 border-red-200 text-red-600 bg-red-50 rounded-lg flex flex-row items-center gap-3"
  >
    <div class="flex-1">{{ message }}</div>
    <Button
      label="Try Again"
      variant="outlined"
      severity="danger"
      size="small"
      @click="emit('tryAgain')"
    />
  </div>
</template>

<script setup lang="ts">
import Button from 'primevue/button';

defineProps<{
  message: string;
}>();

const emit = defineEmits<{
  (e: 'tryAgain'): void;
}>();
</script>
